import { SET_MAP_LEGEND_SHOW, TOGGLE_MAP_LEGEND_SHOW } from './mapLegendUI-actions';

export interface IMapLegendUIState {
    isMapLegendVisible: boolean;
}

const initialState: IMapLegendUIState = {
    isMapLegendVisible: true,
};

export const mapLegendUIReducer = (
    state = initialState,
    action: any
): IMapLegendUIState => {
    switch (action.type) {
        case SET_MAP_LEGEND_SHOW:
            return { ...state, isMapLegendVisible: action.isMapLegendVisible };
        case TOGGLE_MAP_LEGEND_SHOW:
            return { ...state, isMapLegendVisible: !state.isMapLegendVisible };
        default:
            return state;
    }
};